/**
 * Shared registry of AI-generated infographics for WebsiteTech.pro.
 * Source of truth: /app/memory/infographics_manifest.json (kept in sync manually).
 *
 * Import by slug — never inline URLs in component code.
 *
 * Example:
 *   import { INFOGRAPHICS, findInfographic } from "@/data/infographics";
 *   const hero = findInfographic("local-visibility-engine");
 */

const A = "https://customer-assets-lqy194kg.emergentagent.net/job_web-transform-57/artifacts";

export const INFOGRAPHICS = [
  {
    slug: "complete-platform",
    title: "The Complete AI Business Growth Platform",
    tagline: "Build your presence. Find customers. Serve them better. Grow with confidence.",
    url: `${A}/y3ftxuwb_6F099665-FD16-435E-82D4-86243591FB1A.png`,
    featurePath: "/clients",
    featureLabel: "See our client portfolio",
    category: "Overview",
  },
  {
    slug: "industry-solutions",
    title: "Industry Solutions",
    tagline: "One intelligent platform — adapted to how your business actually works.",
    url: `${A}/epkh4cas_6604F717-D4C5-4F39-BF22-3A2CB04DD028.png`,
    featurePath: "/solutions",
    featureLabel: "Explore industry solutions",
    category: "Overview",
  },
  {
    slug: "ai-website-builder",
    title: "AI Website Builder",
    tagline: "From business idea to a professional website. Build smarter. Launch faster.",
    url: `${A}/30ifezip_653D1658-98D6-4056-B49F-D21F13179887.png`,
    featurePath: "/redesign",
    featureLabel: "Try AI redesign",
    category: "Build",
  },
  {
    slug: "website-analysis",
    title: "AI Website Analysis",
    tagline: "Find what is helping your website — and what is holding it back.",
    url: `${A}/fenqoc5y_CE45B65A-4546-4B08-854D-C6E3BF60E76B.png`,
    featurePath: "/si",
    featureLabel: "Open Search Intelligence",
    category: "Grow",
  },
  {
    slug: "local-visibility-engine",
    title: "Local Visibility Engine",
    tagline: "Help nearby customers discover and choose your business.",
    url: `${A}/86mo40yc_087AC0DD-4565-43A2-91F8-10832F9B794D.png`,
    featurePath: "/local-visibility",
    featureLabel: "Run a free Local Visibility audit",
    category: "Grow",
  },
  {
    slug: "unified-lead-customer-hub",
    title: "Unified Lead & Customer Hub",
    tagline: "Every conversation, lead and follow-up in one place.",
    url: `${A}/injscqsi_0E32C030-10FA-4501-B1F0-EC9F025F24DB.png`,
    featurePath: "/inbox",
    featureLabel: "Open the Unified Inbox",
    category: "Grow",
  },
  {
    slug: "ai-marketing-manager",
    title: "AI Marketing Manager",
    tagline: "Know what to improve, why it matters and what to do next.",
    url: `${A}/gh9n1x8q_DD528752-818C-44E4-ACF4-039D0A50A452.png`,
    featurePath: "/marketing-manager",
    featureLabel: "See this week's priorities",
    category: "Grow",
  },
  {
    slug: "reputation-survey-center",
    title: "Reputation & Survey Center",
    tagline: "Listen, respond and build trust with every customer.",
    url: `${A}/s778serk_385CB9F9-B5D1-45CF-8D2B-3010C7FE9F63.png`,
    featurePath: "/reputation",
    featureLabel: "Open Reputation Center",
    category: "Grow",
  },
  {
    slug: "ai-receptionist",
    title: "AI Receptionist",
    tagline: "Welcome every customer — even when your team is busy.",
    url: `${A}/v4363okk_AA327FE8-A855-43F5-8591-27D3E2CF288B.png`,
    featurePath: "/ai-voice",
    featureLabel: "Meet the AI Receptionist",
    category: "Serve",
  },
  {
    slug: "growth-analytics",
    title: "Growth Analytics",
    tagline: "See how your digital activity becomes leads, customers and revenue.",
    url: `${A}/hn6fw372_0BD0E071-C0B8-460F-9F53-9A046F7F8E57.png`,
    featurePath: "/marketing-manager",
    featureLabel: "See growth signals",
    category: "Measure",
  },
  {
    slug: "content-manager",
    title: "AI Content Manager",
    tagline: "Create useful content while keeping your voice and control.",
    url: `${A}/szli2vur_61B170A9-BC05-4B7F-BF3A-19243C96A26F.png`,
    featurePath: "/growth-operator",
    featureLabel: "Draft with Growth Operator",
    category: "Grow",
  },
  {
    slug: "social-media-manager",
    title: "AI Social Media Manager",
    tagline: "Plan, approve and manage your social presence from one place.",
    url: `${A}/ldjmelpe_71C375F3-45EA-4901-9938-22CAF31BF3D7.png`,
    featurePath: "/growth-operator",
    featureLabel: "Plan a campaign",
    category: "Grow",
  },
  {
    slug: "appointment-scheduling",
    title: "Smart Appointment Scheduling",
    tagline: "Make it easy for customers to book — and easier for teams to stay organized.",
    url: `${A}/u56mnsr0_07400C4A-CE64-41C3-ADEB-BCB3C5BACD59.png`,
    featurePath: "/onboarding",
    featureLabel: "Set up your business",
    category: "Serve",
    comingSoon: true,
  },
  {
    slug: "estimates-invoices-payments",
    title: "Estimates, Invoices & Payments",
    tagline: "Move smoothly from customer request to completed payment.",
    url: `${A}/c0yqhdv1_686525B9-C607-4089-9912-58F5CC4B1888.png`,
    featurePath: "/packages",
    featureLabel: "See AI Business tier",
    category: "Serve",
    comingSoon: true,
  },
  {
    slug: "multilingual-websites",
    title: "Multilingual Websites",
    tagline: "Welcome customers in the language they understand.",
    url: `${A}/dadxcall_962F9222-AC57-49EC-8974-4C3D5A60E1A7.png`,
    featurePath: "/qst",
    featureLabel: "See a multilingual example",
    category: "Build",
  },
];

export const findInfographic = (slug) =>
  INFOGRAPHICS.find((i) => i.slug === slug) || null;

export const CATEGORIES = ["Overview", "Build", "Grow", "Serve", "Measure"];
